import { addCastMediaSessionListeners } from "../../setup/castMediaSessionListeners";

export function onCastMediaSession(media: cast.framework.MediaSessionEventData) {
    addCastMediaSessionListeners(media.mediaSession);
}
